<template>
  <div v-if="easyFlowVisible" style="height: calc(50vh);">
    <Row>
      <!--顶部工具菜单-->
      <Col span="24" style="margin-bottom: 10px;">
        <Row style="margin-bottom: 10px;">
          <Col span="8">
            <!-- 节点所属公司 -->
            <Select v-model="companyId" filterable style="width:231px;margin-right: 5px;" @on-change="changeCompany(companyId)"
                    :placeholder="$t('approvalFlowConfigManagement.approvalFlow.pleaseSelectCompany')">
              <Option :value="item.id" v-for="item in companyIdList" v-bind:key="item.id">{{item.name}}</Option>
            </Select>
          </Col>
          <Col span="2">
            <Button @click="deleteElement" :disabled="!this.activeElement.type" style="margin-right: 5px;">
              {{$t('approvalFlowConfigManagement.approvalFlow.delete')}}
            </Button>
          </Col>
          <Col span="4">
            <Button @click="dataInfo">{{$t('approvalFlowConfigManagement.Node.confirmAddNode')}}</Button>
          </Col>
          <Col span="10">
            <div v-model="flowNodeName">{{$t('approvalFlowConfigManagement.Node.title')+" "+flowNodeName}}</div>
          </Col>
        </Row>
      </Col>
    </Row>
    <div style="display: flex;height: calc(100% - 47px);border: 1px solid #dce3e8;">
      <div style="width: 230px;border-right: 1px solid #dce3e8;position: relative;overflow: scroll;">
        <node-menu @addNode="addNode" ref="nodeMenu"></node-menu>
      </div>
      <div id="efContainer" ref="efContainer" class="container" v-flowDrag>
        <template v-for="node in data.nodeList">
          <flow-node :id="node.id" :key="node.id" :node="node" :activeElement="activeElement"
                     @changeNodeSite="changeNodeSite" @nodeRightMenu="nodeRightMenu" @clickNode="clickNode">
          </flow-node>
        </template>
        <!-- 给画布一个默认的宽度和高度 -->
        <div style="position:absolute;top: 2000px;left: 2000px;">&nbsp;</div>
      </div>
    </div>
    <!-- 流程数据详情 -->
    <flow-info v-if="flowInfoVisible" ref="flowInfo" :data="data"></flow-info>
  </div>

</template>

<script>
  import draggable from 'vuedraggable'
  import './jsplumb'
  import {easyFlowMixin} from '@/components/ef/mixins'
  import flowNode from '@/components/ef/node'
  import nodeMenu from '@/components/ef/node_menu'
  import FlowInfo from '@/components/ef/info'
  import lodash from 'lodash'
  import {getDataB} from './data_B'

  export default {
    data() {
      return {
        processTemplate: {},
        processNodeList: [],
        flowNodeName: [],
        companyId: '',
        companyIdList: [],
        // jsPlumb 实例
        jsPlumb: null,
        // 控制画布销毁
        easyFlowVisible: true,
        // 控制流程数据显示与隐藏
        flowInfoVisible: false,
        // 是否加载完毕标志位
        loadEasyFlowFinish: false,
        // 数据
        data: {},
        // 激活的元素、可能是节点、可能是连线
        activeElement: {
          // 可选值 node 、line
          type: undefined,
          // 节点ID
          nodeId: undefined,
          // 连线ID
          sourceId: undefined,
          targetId: undefined
        }
      }
    },
    // 一些基础配置移动该文件中
    mixins: [easyFlowMixin],
    components: {
      draggable, flowNode, nodeMenu, FlowInfo
    },
    directives: {
      'flowDrag': {
        bind(el, binding, vnode, oldNode) {
          if (!binding) {
            return
          }
          el.onmousedown = (e) => {
            if (e.button == 2) {
              // 右键不管
              return
            }
            //  鼠标按下，计算当前原始距离可视区的高度
            let disX = e.clientX
            let disY = e.clientY
            el.style.cursor = 'move'

            document.onmousemove = function (e) {
              // 移动时禁止默认事件
              e.preventDefault()
              const left = e.clientX - disX
              disX = e.clientX
              el.scrollLeft += -left

              const top = e.clientY - disY
              disY = e.clientY
              el.scrollTop += -top
            }

            document.onmouseup = function (e) {
              el.style.cursor = 'auto'
              document.onmousemove = null
              document.onmouseup = null
            }
          }
        }
      }
    },
    mounted() {
      this.jsPlumb = jsPlumb.getInstance()
      this.$nextTick(() => {
        // 默认加载流程A的数据、在这里可以根据具体的业务返回符合流程数据格式的数据即可
        this.dataReload(getDataB());
        this.getCompanyDropDownBox();
      })
    },
    methods: {
      // 清空公司
      deleteCompany: function () {
        this.companyId = '';
      },
      selectProcessById(processTaskId) {
        this.$api.processTemplate.selectProcessById("id", processTaskId)
          .then(async res => {
            this.processTemplate = res.data;
            this.companyId = this.processTemplate.companyId;
            var nodes = await this.$refs.nodeMenu.queryNodesByCompanyId(this.companyId);
            //获取到已有数据
            this.processNodeList = res.data.processNodes;
            var nodeList = [];
            //循环获取已有连接数据
            var top = 10;
            for (let i = 0; i < nodes.length; i++) {
              let children = nodes[i];
              for (let j = 0; j < this.processNodeList.length; j++) {
                if (children.id === this.processNodeList[j].id) {
                  // var lis = document.getElementsByClassName("ef-node-menu-li");
                  // console.log(lis)
                  // for (let k = 0; k < lis.length; k++) {
                  //   if (children.type === lis[k].getAttribute("type")) {
                  //     // this.addNode(lis[k], children, mousePosition)
                  //
                  //   }
                  // }
                  var nodeId = this.getUUID()
                  top += 100;
                  var node = {
                    id: nodeId,
                    ids: children.id,
                    name: children.name,
                    type: children.type,
                    left: i + 10 + 'px',
                    top: top + 'px'
                  }
                  /**
                   * 这里可以进行业务判断、是否能够添加该节点
                   */
                  this.data.nodeList.push(node)
                  this.$nextTick(function () {
                    this.jsPlumb.makeSource(nodeId, this.jsplumbSourceOptions)
                    this.jsPlumb.makeTarget(nodeId, this.jsplumbTargetOptions)
                    this.jsPlumb.draggable(nodeId, {
                      containment: 'parent'
                    })
                  })
                  nodeList.push(node)
                  break;
                }
              }
            }
            //连线
            if (nodeList && nodeList.length > 1) {
              for (let i = 0; i < nodeList.length; i++) {
                if (nodeList[i + 1]) {
                  this.data.lineList.push({from: nodeList[i].id, to: nodeList[i + 1].id})
                  this.$nextTick(function () {
                    this.jsPlumb.connect({
                      source: nodeList[i].id,
                      target: nodeList[i + 1].id
                    }, this.jsplumbConnectOptions)
                  })
                }
              }
            }

            this.dataInfo()
          })
      },
      //公司下拉框
      getCompanyDropDownBox: function () {
        this.companyId = '';
        this.$api.company.getCompanyDropDownBox()
          .then(res => {
            this.companyIdList = res.data;
          })
      },
      // 切换公司
      changeCompany: function () {
        // 清空右边画布数据
        // 节点数组
        // this.data.nodeList = []
        // this.data.lineList = []
        // this.data.name = '';
        // this.flowNodeName=[];
        // var conn = this.jsPlumb.getAllConnections({
        //     source: this.activeElement.sourceId,
        //     target: this.activeElement.targetId
        // })[0]
        // this.jsPlumb.deleteConnection(conn)
        // 调用node_menu页面的queryNodesByCompanyId方法
        this.$refs.nodeMenu.queryNodesByCompanyId(this.companyId);
      },
      // 返回唯一标识
      getUUID() {
        return Math.random().toString(36).substr(3, 10)
      },
      jsPlumbInit() {
        this.jsPlumb.ready(() => {
          // 导入默认配置
          this.jsPlumb.importDefaults(this.jsplumbSetting)
          this.jsPlumb.connect({})
          // 会使整个jsPlumb立即重绘。
          this.jsPlumb.setSuspendDrawing(false, true);
          // 初始化节点
          this.loadEasyFlow()
          // 单点击了连接线, https://www.cnblogs.com/ysx215/p/7615677.html
          this.jsPlumb.bind('click', (conn, originalEvent) => {
            this.activeElement.type = 'line'
            this.activeElement.sourceId = conn.sourceId
            this.activeElement.targetId = conn.targetId
          })
          // 连线
          this.jsPlumb.bind("connection", (evt) => {
            let from = evt.source.id
            let to = evt.target.id
            if (this.loadEasyFlowFinish) {
              this.data.lineList.push({from: from, to: to})
            }
          })

          // 删除连线回调
          this.jsPlumb.bind("connectionDetached", (evt) => {
            this.deleteLine(evt.sourceId, evt.targetId)
          })

          // 改变线的连接节点
          this.jsPlumb.bind("connectionMoved", (evt) => {
            this.changeLine(evt.originalSourceId, evt.originalTargetId)
          })

          // 连线右击
          this.jsPlumb.bind("contextmenu", (evt) => {
            console.log('contextmenu', evt)
          })

          // 连线
          this.jsPlumb.bind("beforeDrop", (evt) => {
            let from = evt.sourceId
            let to = evt.targetId
            if (from === to) {
              this.$Message.error(this.$t('approvalFlowConfigManagement.approvalFlow.nodeNotConnectingItself'))
              return false
            }
            if (this.hasLine(from, to)) {
              this.$Message.error(this.$t('approvalFlowConfigManagement.approvalFlow.relationAlreadyExist'))
              return false
            }
            if (this.hashOppositeLine(from, to)) {
              this.$Message.error(this.$t('approvalFlowConfigManagement.approvalFlow.nodeNotSupportLookBack'));
              return false
            }
            this.$Message.success(this.$t('approvalFlowConfigManagement.approvalFlow.connectionSucceeded'))
            return true
          })

          // beforeDetach
          this.jsPlumb.bind("beforeDetach", (evt) => {
            console.log('beforeDetach', evt)
          })
          this.jsPlumb.setContainer(this.$refs.efContainer)
        })
      },
      // 加载流程图
      loadEasyFlow() {
        // 初始化节点
        for (var i = 0; i < this.data.nodeList.length; i++) {
          let node = this.data.nodeList[i]
          // 设置源点，可以拖出线连接其他节点
          this.jsPlumb.makeSource(node.id, this.jsplumbSourceOptions)
          // // 设置目标点，其他源点拖出的线可以连接该节点
          this.jsPlumb.makeTarget(node.id, this.jsplumbTargetOptions)
          this.jsPlumb.draggable(node.id, {
            containment: 'parent'
          })
        }
        // 初始化连线
        for (var i = 0; i < this.data.lineList.length; i++) {
          let line = this.data.lineList[i]
          this.jsPlumb.connect({
            source: line.from,
            target: line.to,
            label: line.label ? line.label : ''
          }, this.jsplumbConnectOptions)
        }
        this.$nextTick(function () {
          this.loadEasyFlowFinish = true
        })
      },
      // 删除激活的元素
      deleteElement() {
        if (this.activeElement.type === 'node') {
          this.deleteNode(this.activeElement.nodeId)
        } else if (this.activeElement.type === 'line') {
          this.$Modal.confirm({
            title: '提示',
            content: '确定删除所点击的线吗?',
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
              var conn = this.jsPlumb.getConnections({
                source: this.activeElement.sourceId,
                target: this.activeElement.targetId
              })[0]
              this.jsPlumb.deleteConnection(conn)
              this.activeElement.type = '';
              this.flowNodeName = [];
            }
          })
        }
      },
      // 删除线
      deleteLine(from, to) {
        this.data.lineList = this.data.lineList.filter(function (line) {
          if (line.from == from && line.to == to) {
            return false
          }
          return true
        })
      },
      // 改变连线
      changeLine(oldFrom, oldTo) {
        this.deleteLine(oldFrom, oldTo)
      },
      // 改变节点的位置
      changeNodeSite(data) {
        for (var i = 0; i < this.data.nodeList.length; i++) {
          let node = this.data.nodeList[i]
          if (node.id === data.nodeId) {
            node.left = data.left
            node.top = data.top
          }
        }
      },
      /**
       * 拖拽结束后添加新的节点
       * @param evt
       * @param nodeMenu 被添加的节点对象
       * @param mousePosition 鼠标拖拽结束的坐标
       */
      addNode(evt, nodeMenu, mousePosition) {
        var screenX = evt.originalEvent.clientX, screenY = evt.originalEvent.clientY
        let efContainer = this.$refs.efContainer
        var containerRect = efContainer.getBoundingClientRect()
        var left = screenX, top = screenY
        // 计算是否拖入到容器中
        if (left < containerRect.x || left > containerRect.width + containerRect.x || top < containerRect.y || containerRect.y > containerRect.y + containerRect.height) {
          this.$Message.error("请把节点拖入到画布中")
          return
        }
        left = left - containerRect.x + efContainer.scrollLeft
        top = top - containerRect.y + efContainer.scrollTop
        // 居中
        left -= 85
        top -= 16
        var nodeId = this.getUUID()
        // 动态生成名字
        var origName = nodeMenu.name
        var nodeName = origName
        var index = 1
        while (index < 10000) {
          var repeat = false
          for (var i = 0; i < this.data.nodeList.length; i++) {
            let node = this.data.nodeList[i]
            if (node.name === nodeName) {
              nodeName = origName + index
              repeat = true
            }
          }
          if (repeat) {
            index++
            continue
          }
          break
        }
        var node = {
          id: nodeId,
          ids: nodeMenu.id,
          name: nodeName,
          type: nodeMenu.type,
          left: left + 'px',
          top: top + 'px'
        }
        /**
         * 这里可以进行业务判断、是否能够添加该节点
         */
        this.data.nodeList.push(node)
        this.$nextTick(function () {
          this.jsPlumb.makeSource(nodeId, this.jsplumbSourceOptions)
          this.jsPlumb.makeTarget(nodeId, this.jsplumbTargetOptions)
          this.jsPlumb.draggable(nodeId, {
            containment: 'parent'
          })
        })
      },
      /**
       * 删除节点
       * @param nodeId 被删除节点的ID
       */
      deleteNode(nodeId) {
        this.$Modal.confirm({
          title: '提示',
          content: '确定要删除该节点吗?',
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            /**
             * 这里需要进行业务判断，是否可以删除
             */
            this.data.nodeList = this.data.nodeList.filter(function (node) {
              if (node.id === nodeId) {
                // 伪删除，将节点隐藏，否则会导致位置错位
                // node.show = false
                return false
              }
              return true
            })
            this.$nextTick(function () {
              this.jsPlumb.removeAllEndpoints(nodeId);
            })
            this.activeElement.type = '';
            this.flowNodeName = [];
          }
        })
        return true
      },
      clickNode(nodeId) {
        this.activeElement.type = 'node'
        this.activeElement.nodeId = nodeId
      },
      // 是否具有该线
      hasLine(from, to) {
        for (var i = 0; i < this.data.lineList.length; i++) {
          var line = this.data.lineList[i]
          if (line.from === from && line.to === to) {
            return true
          }
        }
        return false
      },
      // 是否含有相反的线
      hashOppositeLine(from, to) {
        return this.hasLine(to, from)
      },
      nodeRightMenu(nodeId, evt) {
        this.menu.show = true
        this.menu.curNodeId = nodeId
        this.menu.left = evt.x + 'px'
        this.menu.top = evt.y + 'px'
      },
      // 流程数据信息
      dataInfo() {
        // 节点传参
        this.flowNodeName = [];
        for (var i = 0; i < this.data.nodeList.length; i++) {
          this.flowNodeName.push(this.data.nodeList[i].ids);
        }
        // this.flowInfoVisible = true
        // this.$nextTick(function () {
        //     this.$refs.flowInfo.init()
        // })
      },
      // 加载流程图
      dataReload(data) {
        this.easyFlowVisible = false
        this.data.nodeList = []
        this.data.lineList = []
        this.$nextTick(() => {
          data = lodash.cloneDeep(data)
          this.easyFlowVisible = true
          this.data = data
          this.$nextTick(() => {
            this.jsPlumb = jsPlumb.getInstance()
            this.$nextTick(() => {
              this.jsPlumbInit()
            })
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ef/panel.vue